<template>
  <div v-show="false"></div>
</template>

<script>
import { mapGetters } from 'vuex';
import { countAiNoticeUnread } from '@/api/aiNotice';
import { helpJsonParse } from '@/utils/index';
import { acquireAiNoticeAlertLock, hasAiNoticePermission, releaseAiNoticeAlertLock } from '@/utils/aiNoticePermission';

export default {
  name: 'AiNoticeNotifier',
  data() {
    return {
      unreadRequestHotelCode: '',
    };
  },
  computed: {
    ...mapGetters(['authList', 'hotelCode']),
    hasAiNoticePermission() {
      return hasAiNoticePermission(this.authList);
    },
  },
  watch: {
    hotelCode: {
      handler(value) {
        if (!value) {
          this.unreadRequestHotelCode = '';
          return;
        }
        this.fetchUnreadCount();
      },
      immediate: true,
    },
    hasAiNoticePermission: {
      handler(value) {
        if (value) {
          this.$nextTick(() => this.showBrowserPermissionGuide());
        }
      },
      immediate: true,
    },
    '$route.path'() {
      this.$nextTick(() => this.showBrowserPermissionGuide());
    },
    '$store.getters.socketMessage'(msg) {
      if (!msg || msg.type !== 'socket' || msg.childrenType !== 'aiNoticeUnreadChanged') {
        return;
      }
      const payload = helpJsonParse(msg.context);
      const unreadCount = Number(payload && payload.unreadCount);
      this.$store.commit('app/SET_AI_NOTICE_UNREAD', Number.isFinite(unreadCount) && unreadCount >= 0 ? unreadCount : 0);
      this.notifyBrowser(payload).catch(() => {});
    },
  },
  methods: {
    /** 查询当前酒店的绝对未读数，避免旧酒店请求晚返回时覆盖新酒店状态。 */
    async fetchUnreadCount() {
      const hotelCode = this.hotelCode;
      if (!hotelCode || this.unreadRequestHotelCode === hotelCode) {
        return;
      }
      this.unreadRequestHotelCode = hotelCode;
      try {
        const res = await countAiNoticeUnread({ hotelCode });
        if (this.hotelCode === hotelCode) {
          this.$store.commit('app/SET_AI_NOTICE_UNREAD', res.data || 0);
        }
      } catch (e) {
        if (this.hotelCode === hotelCode) {
          this.$store.commit('app/SET_AI_NOTICE_UNREAD', 0);
        }
      }
    },
    /** 仅在 AI 页面由用户确认后请求浏览器通知权限。 */
    showBrowserPermissionGuide() {
      if (!this.hotelCode || !this.hasAiNoticePermission || this.$route.path.indexOf('/ai') !== 0 || typeof window === 'undefined' || !window.Notification || window.Notification.permission !== 'default') {
        return;
      }
      const guideKey = `aiNoticeBrowserPermissionGuide:${this.hotelCode}`;
      if (window.sessionStorage.getItem(guideKey)) {
        return;
      }
      window.sessionStorage.setItem(guideKey, '1');
      this.$confirm(this.$t('aiPms.noticeCenter.browserPermissionGuide'), this.$t('aiPms.noticeCenter.browserNotificationTitle'), {
        confirmButtonText: this.$t('aiPms.noticeCenter.enableBrowserNotification'),
        cancelButtonText: this.$t('aiPms.noticeCenter.skipBrowserNotification'),
        type: 'info',
      })
        .then(() => this.requestBrowserPermission())
        .catch(() => {});
    },
    requestBrowserPermission() {
      if (!this.hotelCode || !this.hasAiNoticePermission || typeof window === 'undefined' || !window.Notification || window.Notification.permission !== 'default') {
        return;
      }
      const requestResult = window.Notification.requestPermission();
      if (requestResult && typeof requestResult.catch === 'function') {
        requestResult.catch(() => {});
      }
    },
    async notifyBrowser(payload) {
      if (!this.hotelCode || !this.hasAiNoticePermission || !payload || payload.eventType !== 'SUCCESS' || !payload.noticeNo || typeof window === 'undefined' || !window.Notification || window.Notification.permission !== 'granted') {
        return;
      }
      const hotelCode = this.hotelCode;
      const noticeNo = payload.noticeNo;
      if (!(await acquireAiNoticeAlertLock('browser', hotelCode, noticeNo))) {
        return;
      }
      let notification;
      try {
        notification = new window.Notification(this.$t('aiPms.noticeCenter.browserNotificationTitle'), {
          body: payload.title || payload.summary || this.$t('aiPms.noticeCenter.browserNotificationBody'),
        });
      } catch (e) {
        await releaseAiNoticeAlertLock('browser', hotelCode, noticeNo);
        return;
      }
      notification.onclick = () => {
        window.focus();
        this.$router.push({ path: '/ai/notice/detail', query: { noticeNo } }).catch(() => {});
        notification.close();
      };
    },
  },
};
</script>
